export {AvatarStack} from './AvatarStack';
export type {
    AvatarStackProps,
    AvatarStackOverlapSize,
    AvatarStackMoreProps,
    AvatarStackMoreButtonProps,
} from './types';
